import React, { useState, useRef, useEffect } from "react";
import "./CurvedMenuToggle.css";

export default function CurvedMenuToggle({
  defaultOpen = false,
  curve = "top", // 'top' or 'bottom'
  menuColor = "#d9d9d9", // background color of curve bar
  iconColor = "#333", // icon color
  children,
}) {
  const [open, setOpen] = useState(defaultOpen);
  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (containerRef.current) setWidth(containerRef.current.offsetWidth);
    const handleResize = () => setWidth(containerRef.current?.offsetWidth || 0);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div ref={containerRef} className={`curved-menu ${open ? "open" : "closed"}`}>
      {/* Independent Content */}
      <div className="curved-content">{children}</div>

      {/* Curve bar + toggle icon */}
      <div className="curve-bar-wrapper" onClick={() => setOpen(!open)}>
        <svg
          width={width}
          height="40"
          viewBox={`0 0 ${width} 40`}
          preserveAspectRatio="none"
          className={`curve-svg ${curve}`}
        >
          <path d={generateCurvePath(width, curve)} fill={menuColor} />
        </svg>
        <span className="curve-icon" style={{ color: iconColor }}>
          {open ? "✕" : "☰"}
        </span>
      </div>
    </div>
  );
}

/* Generates top/bottom curve shapes */
function generateCurvePath(width, curve) {
  const flatHeight = 10;
  const curveHeight = 25;
  const iconCenter = width - 70;
  const startCurve = iconCenter - 50;
  const endCurve = iconCenter + 50;

  if (curve === "top") {
    return `
      M0,${flatHeight}
      H${startCurve}
      Q${iconCenter},${-curveHeight} ${endCurve},${flatHeight}
      H${width}
      V40 H0 Z
    `;
  } else {
    const baseline = 40 - flatHeight;
    const bottomCurveY = 40 + curveHeight;
    return `
      M0,${baseline}
      H${startCurve}
      Q${iconCenter},${bottomCurveY} ${endCurve},${baseline}
      H${width}
      V0 H0 Z
    `;
  }
}
